import { apiDataManagerBaseURL } from '../../authentication/Global';
import { authenticationCentral } from '../../authentication/Authentication';
import { API, HTTPMethod, ContentType } from '../APICentral';

const tripsApiRoutes = {
    list: apiDataManagerBaseURL + "trips/",
    listDraft: apiDataManagerBaseURL + "tripsdraft/",
    load: apiDataManagerBaseURL + "trips/",
    loadByPathAndSched: apiDataManagerBaseURL + "trips/bypathandschedule/",
    loadByPathSchedIdDraft: apiDataManagerBaseURL + "tripsdraft/bypathandschedule/",
    loadByPathAndSchedCodeDraft: apiDataManagerBaseURL + "tripsdraft/bypathandschedulecode/",
    intervals: apiDataManagerBaseURL + "trips/intervals/",
    intervalsDraft: apiDataManagerBaseURL + "tripsdraft/intervals/",
    notes: apiDataManagerBaseURL + "trips/notes/",
    notesDraft: apiDataManagerBaseURL + "tripsdraft/notes/",
    countActiveNetwork: apiDataManagerBaseURL + "trips/count/",
    countDraft: apiDataManagerBaseURL + "tripsdraft/count/",
    create: apiDataManagerBaseURL + "trips/",
    update: apiDataManagerBaseURL + "trips/",
    updateDraft: apiDataManagerBaseURL + "tripsdraft/",
    delete: apiDataManagerBaseURL + "trips/",
    deleteDraft: apiDataManagerBaseURL + "tripsdraft/",
    moveTrip: apiDataManagerBaseURL + "trips/moveTrip/",
    moveTripDraft: apiDataManagerBaseURL + "tripsdraft/moveTrip/",
    copyTrip: apiDataManagerBaseURL + "trips/copyTrip/",
    copyTripDraft: apiDataManagerBaseURL + "tripsdraft/copyTrip/"
};

export class TripAPI {
    static list(networkEdition, planningEdition, provider = '') {
        const url = new URL(`${networkEdition}/${planningEdition}`, tripsApiRoutes.list);

        return API.authenticatedRequest({
            url: provider === '' ? url : `${url}?provider=${provider}`,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static listDraft(draftNetworkEdition, draftPlanningEdition, provider = '') {
        const url = new URL(`${draftNetworkEdition}/${draftPlanningEdition}`, tripsApiRoutes.listDraft);

        return API.authenticatedRequest({
            url: provider === '' ? url : `${url}?provider=${provider}`,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static load(networkEdition, planningEdition, id) {
        const url = new URL(`${networkEdition}/${planningEdition}/${id}`, tripsApiRoutes.load);

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static loadByPathAndSched(networkEdition, planningEdition, pathId, scheduleId, provider = '') {
        const url = new URL(`${networkEdition}/${planningEdition}/${pathId}/${scheduleId}`, tripsApiRoutes.loadByPathAndSched);

        return API.authenticatedRequest({
            url: provider === '' ? url : `${url}?provider=${provider}`,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static loadByPathAndSchedWithActiveDraft(networkEdition, draftNetworkEdition, draftPlanningEdition, pathId, scheduleId, provider = '') {
        const url = new URL(`${networkEdition}/${draftNetworkEdition}/${draftPlanningEdition}/${pathId}/${scheduleId}`, tripsApiRoutes.loadByPathSchedIdDraft);

        return API.authenticatedRequest({
            url: provider === '' ? url : `${url}?provider=${provider}`,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static loadByPathAndSchedCodeDraft(networkEdition, draftNetworkEdition, draftPlanningEdition, pathCode, scheduleCode, provider = '') {
        const url = new URL(`${networkEdition}/${draftNetworkEdition}/${draftPlanningEdition}/${pathCode}/${scheduleCode}`, tripsApiRoutes.loadByPathAndSchedCodeDraft);

        return API.authenticatedRequest({
            url: provider === '' ? url : `${url}?provider=${provider}`,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static getIntervals(networkEdition, planningEdition, id, provider = '') {
        const url = new URL(`${networkEdition}/${planningEdition}/${id}`, tripsApiRoutes.intervals);

        return API.authenticatedRequest({
            url: provider === '' ? url : `${url}?provider=${provider}`,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static getIntervalsDraft(draftNetworkEdition, draftPlanningEdition, id, provider = '') {
        const url = new URL(`${draftNetworkEdition}/${draftPlanningEdition}/${id}`, tripsApiRoutes.intervalsDraft);

        return API.authenticatedRequest({
            url: provider === '' ? url : `${url}?provider=${provider}`,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static getIntervalsWithActiveDraft(networkEdition, draftNetworkEdition, draftPlanningEdition, id, provider = '') {
        const url = new URL(`${networkEdition}/${draftNetworkEdition}/${draftPlanningEdition}/${id}`, tripsApiRoutes.intervalsDraft);

        return API.authenticatedRequest({
            url: provider === '' ? url : `${url}?provider=${provider}`,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static getNotes(networkEdition, planningEdition, id, provider = '') {
        const url = new URL(`${networkEdition}/${planningEdition}/${id}`, tripsApiRoutes.notes);

        return API.authenticatedRequest({
            url: provider === '' ? url : `${url}?provider=${provider}`,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static getNotesDraft(draftNetworkEdition, draftPlanningEdition, id, provider = '') {
        const url = new URL(`${draftNetworkEdition}/${draftPlanningEdition}/${id}`, tripsApiRoutes.notesDraft);

        return API.authenticatedRequest({
            url: provider === '' ? url : `${url}?provider=${provider}`,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static getNotesWithActiveDraft(networkEdition, draftNetworkEdition, draftPlanningEdition, id, provider = '') {
        const url = new URL(`${networkEdition}/${draftNetworkEdition}/${draftPlanningEdition}/${id}`, tripsApiRoutes.notesDraft);

        return API.authenticatedRequest({
            url: provider === '' ? url : `${url}?provider=${provider}`,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static moveTrip(sched, tripId, networkEdition, planningEdition) {
        const url = new URL(`${tripId}/${networkEdition}/${planningEdition}`, tripsApiRoutes.moveTrip);
        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.POST,
            contentType: ContentType.JSON,
            body: JSON.stringify(sched),
            token: authenticationCentral.accessToken
        });
    }

    static moveTripDraft(sched, tripId, networkEdition, planningEdition) {
        const url = new URL(`${tripId}/${networkEdition}/${planningEdition}`, tripsApiRoutes.moveTripDraft);
        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.POST,
            contentType: ContentType.JSON,
            body: JSON.stringify(sched),
            token: authenticationCentral.accessToken
        });
    }

    static copyTrip(sched, tripId, networkEdition, planningEdition) {
        const url = new URL(`${tripId}/${networkEdition}/${planningEdition}`, tripsApiRoutes.copyTrip);

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.PUT,
            contentType: ContentType.JSON,
            body: JSON.stringify(sched),
            token: authenticationCentral.accessToken
        });
    }

    static copyTripDraft(sched, tripId, networkEdition, planningEdition) {
        const url = new URL(`${tripId}/${networkEdition}/${planningEdition}`, tripsApiRoutes.copyTripDraft);

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.PUT,
            contentType: ContentType.JSON,
            body: JSON.stringify(sched),
            token: authenticationCentral.accessToken
        });
    }

    static countActive(networkEdition, planningEdition, providerId = '') {
        const url = new URL(`${networkEdition}/${planningEdition}`, tripsApiRoutes.countActiveNetwork);

        return API.authenticatedRequest({
            url: providerId === '' ? url : `${url}?providerId=${providerId}`,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static countDraft(networkEdition, draftNetworkEdition, draftPlanningEdition, providerId = '') {
        const url = new URL(`${networkEdition}/${draftNetworkEdition}/${draftPlanningEdition}`, tripsApiRoutes.countDraft);

        return API.authenticatedRequest({
            url: providerId === '' ? url : `${url}?providerId=${providerId}`,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static create(networkEdition, planningEdition, trip) {
        const url = new URL(`${networkEdition}/${planningEdition}`, tripsApiRoutes.create);

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.POST,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(trip)
        });
    }

    static update(networkEdition, planningEdition, trips) {
        const url = new URL(`${networkEdition}/${planningEdition}`, tripsApiRoutes.update);

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.PUT,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(trips)
        });
    }

    static updateDraft(draftNetworkEdition, draftPlanningEdition, trips) {
        const url = new URL(`${draftNetworkEdition}/${draftPlanningEdition}`, tripsApiRoutes.updateDraft);

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.PUT,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(trips)
        });
    }

    static saveIntervals(networkEdition, planningEdition, id, intervals, provider = '') {
        const url = new URL(`${networkEdition}/${planningEdition}/${id}`, tripsApiRoutes.intervals);

        return API.authenticatedRequest({
            url: provider === '' ? url : `${url}?provider=${provider}`,
            method: HTTPMethod.PUT,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(intervals)
        });
    }

    static saveIntervalsDraft(draftNetworkEdition, draftPlanningEdition, id, intervals, provider = '') {
        const url = new URL(`${draftNetworkEdition}/${draftPlanningEdition}/${id}`, tripsApiRoutes.intervalsDraft);

        return API.authenticatedRequest({
            url: provider === '' ? url : `${url}?provider=${provider}`,
            method: HTTPMethod.PUT,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(intervals)
        });
    }

    static saveIntervalsWithActiveDraft(networkEdition, draftNetworkEdition, draftPlanningEdition, id, intervals, provider = '') {
        const url = new URL(`${networkEdition}/${draftNetworkEdition}/${draftPlanningEdition}/${id}`, tripsApiRoutes.intervalsDraft);

        return API.authenticatedRequest({
            url: provider === '' ? url : `${url}?provider=${provider}`,
            method: HTTPMethod.PUT,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(intervals)
        });
    }

    static saveNotes(networkEdition, planningEdition, id, notes, provider = '') {
        const url = new URL(`${networkEdition}/${planningEdition}/${id}`, tripsApiRoutes.notes);

        return API.authenticatedRequest({
            url: provider === '' ? url : `${url}?provider=${provider}`,
            method: HTTPMethod.PUT,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(notes)
        });
    }

    static saveNotesDraft(draftNetworkEdition, draftPlanningEdition, id, notes, provider = '') {
        const url = new URL(`${draftNetworkEdition}/${draftPlanningEdition}/${id}`, tripsApiRoutes.notesDraft);

        return API.authenticatedRequest({
            url: provider === '' ? url : `${url}?provider=${provider}`,
            method: HTTPMethod.PUT,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(notes)
        });
    }

    static saveNotesWithActiveDraft(networkEdition, draftNetworkEdition, draftPlanningEdition, id, notes, provider = '') {
        const url = new URL(`${networkEdition}/${draftNetworkEdition}/${draftPlanningEdition}/${id}`, tripsApiRoutes.notesDraft);

        return API.authenticatedRequest({
            url: provider === '' ? url : `${url}?provider=${provider}`,
            method: HTTPMethod.PUT,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(notes)
        });
    }

    static delete(networkEdition, planningEdition, id) {
        const url = new URL(`${networkEdition}/${planningEdition}/${id}`, tripsApiRoutes.delete);

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.DELETE,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static deleteDraft(draftNetworkEdition, draftPlanningEdition, id) {
        const url = new URL(`${draftNetworkEdition}/${draftPlanningEdition}/${id}`, tripsApiRoutes.deleteDraft);

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.DELETE,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static deleteTrips(networkEdition, planningEdition, trips) {
        const url = new URL(`${networkEdition}/${planningEdition}`, tripsApiRoutes.delete);

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.DELETE,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(trips)
        });
    }

    static deleteDraftTrips(draftNetworkEdition, draftPlanningEdition, trips) {
        const url = new URL(`${draftNetworkEdition}/${draftPlanningEdition}`, tripsApiRoutes.deleteDraft);

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.DELETE,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(trips)
        });
    }
}



// WEBPACK FOOTER //
// ./src/api/datamanager/TripAPI.js